import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";

export default function DualLensHeader({
	url,
	status,
	statusLabel,
	isProcessing,
	onRegenerate,
}) {
	const navigate = useNavigate();
	const isCompleted = String(status || "").toLowerCase() === "completed";

	return (
		<div className="dual-lens__header">
			<div className="dual-lens__header-left">
				<button
					type="button"
					className="dual-lens__back"
					onClick={() => navigate("/aivisibility/dual-lens")}
				>
					<i className="fas fa-arrow-left me-2" />
					Dual Lens View
				</button>
				{url && (
					<a
						href={url}
						target="_blank"
						rel="noopener noreferrer"
						className="dual-lens__header-url"
					>
						{url}
					</a>
				)}
			</div>
			<div className="dual-lens__header-actions">
				<Button
					color="light"
					className="dual-lens__regenerate-header-btn border"
					disabled={isProcessing}
					onClick={onRegenerate}
				>
					<i className="fas fa-sync-alt me-2" />
					Regenerate
				</Button>
				{statusLabel && (
					<span
						className={`dual-lens__status-badge ${
							isCompleted ? "dual-lens__status-badge--ready" : ""
						}`}
					>
						{isCompleted && <i className="fas fa-check-circle me-1" />}
						{statusLabel}
					</span>
				)}
			</div>
		</div>
	);
}
